import { render, staticRenderFns } from "./hasElectricBoardLessThanTenYears.vue?vue&type=template&id=11d36bd8&scoped=true"
import script from "./hasElectricBoardLessThanTenYears.vue?vue&type=script&lang=ts"
export * from "./hasElectricBoardLessThanTenYears.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d36bd8",
  null
  
)

export default component.exports